import StringUtil from "./string.js";

const Util = {
  exportarAtendimentosCSV(atendimentos) {
    if (atendimentos.length === 0) return false;

    let csvContent = "data:text/csv;charset=utf8,\uFEFF";
    csvContent +=
      '"Id";' +
      //"\"Usuario\";" +
      '"Data";' +
      '"Entrada";' +
      '"Saida";' +
      '"Total";' +
      '"Procedimento";' +
      '"Descricao";' +
      '"Cidade";' +
      '"Dt. Nasc.";' +
      '"Paciente";' +
      '"Profissional";' +
      '"Atendimento"\r\n';

    atendimentos.forEach(function (atendimento) {
      let row = "";
      row += "" + atendimento.id + ";";
      //row += "" + atendimento.criadorNome + ";";
      row += "" + atendimento.data + ";";
      row += "" + atendimento.horaEntrada + ";";
      row += "" + atendimento.horaSaida + ";";
      row += "" + atendimento.horaTotal + ";";
      row +=
        "" +
        atendimento.procedimento.codigo +
        " - " +
        atendimento.procedimento.descricao +
        ";";
      row += "" + atendimento.descricao + ";";
      row += "" + atendimento.cidade + ";";
      row +=
        "" +
        (!atendimento.paciente.dataNascimento
          ? ""
          : atendimento.paciente.dataNascimento) +
        ";";
      row +=
        '"' +
        atendimento.paciente.idCismepar +
        " - " +
        atendimento.paciente.nome +
        '";';

      let profissional = "";
      let count = atendimento.valores.length;
      for (var i = 0; i < count; i++) {
        profissional += atendimento.valores[i].usuarioNome;
        profissional += i + 1 < count ? "," : "";
      }

      let tipo = "PRIMEIRA CONSULTA";
      if (atendimento.tipo === 2) tipo = "RETORNO";
      else if (atendimento.tipo === 3) tipo = "CANCELADO";

      row += "" + profissional + ";";
      row += "" + tipo + ";";
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "atendimentos.csv");
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    return true;
  },

  exportarReunioesCSV(reunioes) {
    if (reunioes.length === 0) return false;

    let csvContent = "data:text/csv;charset=utf8,\uFEFF";
    csvContent +=
      '"Id";' +
      //"\"Usuario\";" +
      '"Data";' +
      '"Entrada";' +
      '"Saida";' +
      '"Total";' +
      '"Procedimento";' +
      '"Pauta";' +
      '"Ata";' +
      '"Profissional";' +
      '"Reuniao"\r\n';

    reunioes.forEach(function (reuniao) {
      let row = "";
      row += "" + reuniao.id + ";";
      //row += "" + reuniao.criadorNome + ";";
      row += "" + reuniao.data + ";";
      row += "" + reuniao.horaEntrada + ";";
      row += "" + reuniao.horaSaida + ";";
      row += "" + reuniao.horaTotal + ";";
      row +=
        "" +
        reuniao.procedimento.codigo +
        " - " +
        reuniao.procedimento.descricao +
        ";";
      row += "" + reuniao.pauta + ";";
      row +=
        "" +
        (reuniao.procedimento.ataReuniao
          ? (reuniao.id < 10 ? "0" : "") + reuniao.id
          : "NÃO") +
        ";";

      let profissional = "";
      let count = reuniao.valores.length;
      for (var i = 0; i < count; i++) {
        profissional += reuniao.valores[i].usuarioNome;
        profissional += i + 1 < count ? "," : "";
      }

      let tipo = "CONFIRMADA";
      if (reuniao.tipo === 2) tipo = "CANCELADA";

      row += "" + profissional + ";";
      row += "" + tipo + ";";
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "reunioes.csv");
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    return true;
  },

  exportarPacientesCSV(pacientes) {
    if (pacientes.length === 0) return false;

    let csvContent = "data:text/csv;charset=utf8,\uFEFF";
    csvContent +=
      '"Id";' +
      '"Nome";' +
      '"Sexo";' +
      '"ID Cismepar";' +
      '"CPF";' +
      '"RG";' +
      '"CNS";' +
      '"Email";' +
      '"Dt. Nasc.";' +
      '"Tel. Resid.";' +
      '"Tel. Comerc.";' +
      '"Nome Pai";' +
      '"Nome Mãe";' +
      '"Estado Civil";' +
      '"Classificação";' +
      '"Situção";' +
      '"Estado";' +
      '"Cidade";' +
      '"Logradouro";' +
      '"Número";' +
      '"CEP";' +
      '"Bairro";' +
      '"Complemento";' +
      '"Ponto Refer.";' +
      '"Obs"\r\n';

    pacientes.forEach(function (paciente) {
      let row = "";
      row += "" + paciente.id + ";";
      row += "" + paciente.nome + ";";
      row += "" + paciente.sexo + ";";
      row += "" + paciente.idCismepar + ";";
      row += "" + paciente.cpf + ";";
      row += "" + paciente.rg + ";";
      row += "" + paciente.cns + ";";
      row += "" + paciente.email + ";";
      row +=
        "" + (!paciente.dataNascimento ? "" : paciente.dataNascimento) + ";";
      row += "" + paciente.telefoneResidencial + ";";
      row += "" + paciente.telefoneComercial + ";";
      row += "" + paciente.nomePai + ";";
      row += "" + paciente.nomeMae + ";";
      row += "" + StringUtil.estadoCivil(paciente.estadoCivil) + ";";
      row += "" + StringUtil.classificacao(paciente.classificacao) + ";";
      row += "" + StringUtil.tipoInativacao(paciente.tipoInativacao) + ";";
      row += "" + paciente.endereco.estado + ";";
      row += "" + paciente.endereco.cidade + ";";
      row += "" + paciente.endereco.logradouro + ";";
      row += "" + paciente.endereco.numero + ";";
      row += "" + paciente.endereco.cep + ";";
      row += "" + paciente.endereco.bairro + ";";
      row += "" + paciente.endereco.complemento + ";";
      row += "" + paciente.endereco.pontoReferencia + ";";
      row += "" + (!paciente.observacoes ? "" : paciente.observacoes);
      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "pacientes.csv");
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    return true;
  },

  exportarProcedimentosCSV(procedimentos) {
    if (procedimentos.length === 0) return false;
    let csvContent = "data:text/csv;charset=utf8,\uFEFF";
    csvContent +=
      '"Id";' +
      '"Código";' +
      '"Data Vigência";' +
      '"Valor Receber (R$)";' +
      '"Unidade";' +
      '"Tipo";' +
      '"Grupo de Pacientes";' +
      '"Imprime Nº ATA Reunião";' +
      '"Usa Quantidade";' +
      '"Ativo";' +
      '"Profissional";' +
      '"Unidade Pagamento";' +
      '"Valor Pagar (R$)"\r\n';

    let unidades = ["", "HORA", "LANÇAMENTO"];
    let tipos = ["", "ATENDIMENTO", "ATIVIDADE / REUNIÃO"];

    procedimentos.forEach(function (procedimento) {
      procedimento.valores.forEach(function (valor) {
        let row = "";
        row += "" + procedimento.id + ";";
        row += "" + procedimento.codigo + ";";
        row += "" + procedimento.dataVigencia + ";";
        row +=
          '"R$ ' +
          procedimento.valorReceber.toFixed(2).replace(".", ",") +
          '";';
        row += "" + unidades[procedimento.unidade] + ";";
        row += "" + tipos[procedimento.tipo] + ";";
        row += "" + (procedimento.grupoPaciente ? "SIM" : "NÃO") + ";";
        row += "" + (procedimento.ataReuniao ? "SIM" : "NÃO") + ";";
        row += "" + (procedimento.usaQuantidade ? "SIM" : "NÃO") + ";";
        row += "" + (procedimento.inativo ? "NÃO" : "SIM") + ";";
        row += "" + valor.usuarioNome + ";";
        row += "" + unidades[valor.unidade] + ";";
        row += '"R$ ' + valor.valorPagar.toFixed(2).replace(".", ",") + '"';
        csvContent += row + "\r\n";
      });
    });

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "procedimentos.csv");
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    return true;
  },

  exportarLancamentoCSV(lancamento) {
    if (lancamento.length === 0) return false;

    let csvContent = "data:text/csv;charset=utf8,\uFEFF";
    csvContent +=
      '"Id";' +
      '"Origem";' +
      '"Data";' +
      '"Descrição";' +
      '"Nota Fiscal";' +
      '"Pago a";' +
      '"Forma de Pagamento";' +
      '"Valor";' +
      '"Categoria";' +
      '"Situação";' +
      '"Periodicidade";' +
      '"Tipo";' +
      '"Observação";' +
      '"Pago"\r\n';

    lancamento.forEach(function (lancamento) {
      let row = "";
      row += "" + lancamento.id + ";";
      row += "" + lancamento.origem + ";";
      row += "" + lancamento.data + ";";
      row += "" + lancamento.descricao + ";";
      row += "" + lancamento.notaFiscal + ";";
      row += "" + lancamento.pagoDe + ";";
      lancamento.formaPagamento
        ? (row += "" + lancamento.formaPagamento.descricao + ";")
        : (row += ";");
      row += "" + lancamento.valor + ";";
      lancamento.categoria
        ? (row += "" + lancamento.categoria.descricao + ";")
        : (row += ";");
      row += "" + lancamento.situacao + ";";
      row += "" + lancamento.periodicidade + ";";
      row += "" + lancamento.tipo + ";";
      row += "" + lancamento.observacao + ";";
      row += "" + lancamento.pago + ";";

      csvContent += row + "\r\n";
    });

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "lancamento.csv");
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    return true;
  },
};

export default Util;
